import { AuthService } from '@service/auth.service';
import { Reminder } from '@models/reminder';
import { PushToken } from '@models/push-token';

interface AuthData {
  accessToken: string;
  expirationDate: number;
}

export class MobileService {
  public static readonly instance = new MobileService();

  auth (data: AuthData) {
    window.ArgoliMobile?.postMessage(JSON.stringify({
      type: 'auth',
      data,
    }));
  }

  async retrieveAuthData() {
    const res = await AuthService.instance.getAccessToken();
    window.ArgoliMobile?.postMessage(JSON.stringify({
      type: 'async',
      methodName: 'retrieveAuthData',
      data: res
    }));
  }

  async onAppReady() {
    window.flutter_inappwebview?.callHandler('onAppReady');
  }

  //Custom navigation handling
  navigateToApp(path: string, state: any) {
    window.dispatchEvent(
      new CustomEvent('argoli:navigate', {
        detail: { path, state }
      })
    );
  };

  async acceptReminderCall(reminder: Reminder) {
    const state = {
      reminderId: reminder.id,
      patientId: reminder.patientId,
      activityType: reminder.activityType,
    };

    this.navigateToApp("/portal/talk", state);
  }

  async registerPushToken(pushTokenJson: string) {
    let subscription: any;
    try {
      // Parse the serialized PushToken JSON string
      const pushToken: PushToken = JSON.parse(pushTokenJson);

      // Dynamically import store and pushTokenApi to avoid circular imports
      const mod = await import('@store/pushTokenApi');
      const storeMod = await import('@store/store');
      const pushTokenApi = mod.pushTokenApi;
      const store = storeMod.store;

      const action = pushTokenApi.endpoints.registerPushToken.initiate(pushToken);
      subscription = store.dispatch(action);
      const result: any = await subscription;

      if (result && result.data) {
        return result.data as PushToken;
      }

      console.error('Failed to register push token', result?.error || result);
      return null;
    } catch (e) {
      console.error('Exception while registering push token', e);
      return null;
    } finally {
      try { subscription?.unsubscribe?.(); } catch (e) { /* ignore */ }
    }
  }

  async deletePushToken(token: string) {
    let subscription: any;
    try {
      // Dynamically import store and pushTokenApi to avoid circular imports
      const mod = await import('@store/pushTokenApi');
      const storeMod = await import('@store/store');
      const pushTokenApi = mod.pushTokenApi;
      const store = storeMod.store;

      const action = pushTokenApi.endpoints.deletePushToken.initiate({ token });
      subscription = store.dispatch(action);
      const result: any = await subscription;

      if (result && result.data) {
        return result.data as PushToken;
      }

      console.error('Failed to delete push token', result?.error || result);
      return null;
    } catch (e) {
      console.error('Exception while deleting push token', e);
      return null;
    } finally {
      try { subscription?.unsubscribe?.(); } catch (e) { /* ignore */ }
    }
  }

  async isPatient() {
    return AuthService.instance.isPatient;
  }
}

if (window.ArgoliMobile) {
  window.ArgoliMobile.mobileService = MobileService.instance;
}